// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"86":"44a2140049e4841c","289":"8795b73df9703d29","604":"f22edbcf8249e661"}[chunkId] + ".js";
};